import { useEffect } from 'react';
import Select, { SelectProps } from '../components/Select';
import { useCommonRequestsYearsQuery } from '../services/common-requests/common-requests.service';
import { useErrorToast } from '../hooks/useToast';

type CommonRequestYearSelectProps = Omit<SelectProps<string>, 'options'>;

const CommonRequestYearSelect = ({ selected, onChange, ...selectProps }: CommonRequestYearSelectProps) => {

  const {
    data: years,
    error: yearsError,
  } = useCommonRequestsYearsQuery(
    );

  useEffect(() => {
    if (yearsError) {
      useErrorToast('Eroare la preluarea anilor comuni.')
    }
  }, [yearsError]);


  return (
    <Select
      {...selectProps}
      placeholder={`An`}
      options={years?.length ? years?.map(((year: number) => ({ key: year.toString(), value: year.toString() }))) : []}
      onChange={onChange}
      selected={selected}
    />
  );
};

export default CommonRequestYearSelect;
